export default __webpack_public_path__ + "static/media/temp-virtual-card-mage.b78aa5b4.png";